import { axios } from "@ui/http";
const useApiClient = ()=>axios;
export { useApiClient };
